document.addEventListener('DOMContentLoaded', () => {
    const btn = document.getElementById('reload')
    const captcha = document.getElementById('captcha-image')

    if (!btn || !captcha) return

    btn.addEventListener('click', () => {
        captcha.src = captcha.src.split('?')[0] + '?' + Date.now()
    })
})
